import React from 'react';
import {FormattedMessage} from "react-intl";

const PaymentCancel = () => (
    <h1><FormattedMessage id="page.payment.cancel.header"/></h1>
);

export default PaymentCancel;